<template>
  <div class="screw-body">
    <div class="screw-body-inner">
      <div class="screw-body-inner-left">
        <div class="screw-left-logo">
          <div class="screw-left-logo-img">
            <img src="../../../static/img/sicon/tupian.png">
          </div>
          <div class="screw-left-logo-text">
            <div class="text1">城工科技绿洲23#楼空调主机控制界面</div>
            <div class="text2">{{ homeTime }} {{ weather }} {{ temp }}℃</div>
            <div class="text3"><span
                style="color: yellow;">注意：</span>物业人员操作【空调系统启动】或【空调系统关闭】按钮后，请核对循环泵、空调的运行状态及功率曲线，确认运行正常后，方可离开。</div>
          </div>
        </div>
        <div class="screw-left-body">
          <div class="screw-left-main10">
            <div class="screw-left-main10-all">
              <div class="screw-left-main10-left">功率曲线（单位：W）</div>
              <div class="screw-left-main10-right">F10</div>
            </div>
            <div ref="pieTen" style="width: 100%; height: 18vh"></div>
          </div>
          <div class="screw-left-main8">
            <div class="screw-left-main10-all">
              <div class="screw-left-main10-left">功率曲线（单位：W）</div>
              <div class="screw-left-main10-right">F8</div>
            </div>
            <div ref="pieEight" style="width: 100%; height: 18vh"></div>
          </div>
          <div class="screw-left-main6">
            <div class="screw-left-main10-all">
              <div class="screw-left-main10-left">功率曲线（单位：W）</div>
              <div class="screw-left-main10-right">F6</div>
            </div>
            <div ref="pieSix" style="width: 100%; height: 18vh"></div>
          </div>
          <div class="screw-left-main4">
            <div class="screw-left-main10-all">
              <div class="screw-left-main10-left">功率曲线（单位：W）</div>
              <div class="screw-left-main10-right">F4</div>
            </div>
            <div ref="pieFour" style="width: 100%; height: 18vh"></div>
          </div>
          <div class="screw-left-main2">
            <div class="screw-left-main10-all">
              <div class="screw-left-main10-left">功率曲线（单位：W）</div>
              <div class="screw-left-main10-right">F2</div>
            </div>
            <div ref="pieTwo" style="width: 100%; height: 17vh"></div>
          </div>
        </div>
      </div>
      <div class="screw-body-inner-center">
        <!-- <div class="screw-center-tit">
          F11 <span style="color: #28A1FE;">------</span>
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b11.value == 0" @click="switchBeng(11, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b11.value == 1" @click="switchBeng(11, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b11.value == 0" @click="switchKong(11, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b11.value == 1" @click="switchKong(11, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b11.value == 0" @click="switchModel(11, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b11.value == 1" @click="switchModel(11, 0)">制热 ☀</div>
        </div> -->
        <!-- F11 -->
        <div class="screw-center-btn" style="padding-top: 1.5vh;">
          <div style="float: right;width: 43%;">
            <div class="screw-center-btn-1" @click="switchBeng(11, 1)">空调系统启动</div>
            <div class="screw-center-btn-2">
              <div class="screw-center-btn-2-1" id="xunhuanbeng11">循环泵</div>
              <div class="screw-center-btn-2-2" id="kongtiao11">空调</div>
            </div>
            <div class="screw-center-btn-3" @click="switchKong(11, 0)">空调系统关闭</div>
            <div class="screw-center-btn-4" @click="switchModel(11, modelArr.b11.value)">
              <span class="zhileng" id="zhileng11">制冷</span>
              <span class="xiegang">/</span>
              <span class="zhire" id="zhire11">制热</span>
            </div>
          </div>
        </div>

        <!-- F9-F10 -->
        <div class="screw-center-btn-all">
          <div class="screw-center-btn1">
            <div style="width: 85%;">
              <div class="screw-center-btn-1" @click="switchBeng(10, 1)">空调系统启动</div>
              <div class="screw-center-btn-2">
                <div class="screw-center-btn-2-1" id="xunhuanbeng10">循环泵</div>
                <div class="screw-center-btn-2-2" id="kongtiao10">空调</div>
              </div>
              <div class="screw-center-btn-3" @click="switchKong(10, 0)">空调系统关闭</div>
              <div class="screw-center-btn-4" @click="switchModel(10, modelArr.b10.value)">
                <span class="zhileng" id="zhileng10">制冷</span>
                <span class="xiegang">/</span>
                <span class="zhire" id="zhire10">制热</span>
              </div>
            </div>
          </div>

          <div class="screw-center-btn2">
            <div style="width: 85%;float: right;">
              <div class="screw-center-btn-1" @click="switchBeng(9, 1)">空调系统启动</div>
              <div class="screw-center-btn-2">
                <div class="screw-center-btn-2-1" id="xunhuanbeng09">循环泵</div>
                <div class="screw-center-btn-2-2" id="kongtiao09">空调</div>
              </div>
              <div class="screw-center-btn-3" @click="switchKong(9, 0)">空调系统关闭</div>
              <div class="screw-center-btn-4" @click="switchModel(9, modelArr.b09.value)">
                <span class="zhileng" id="zhileng09">制冷</span>
                <span class="xiegang"> / </span>
                <span class="zhire" id="zhire09">制热</span>
              </div>
            </div>
          </div>
        </div>

        <!-- F7-F8 -->
        <div class="screw-center-btn-all">
          <div class="screw-center-btn1">
            <div style="width: 85%;">
              <div class="screw-center-btn-1" @click="switchBeng(8, 1)">空调系统启动</div>
              <div class="screw-center-btn-2">
                <div class="screw-center-btn-2-1" id="xunhuanbeng08">循环泵</div>
                <div class="screw-center-btn-2-2" id="kongtiao08">空调</div>
              </div>
              <div class="screw-center-btn-3" @click="switchKong(8, 0)">空调系统关闭</div>
              <div class="screw-center-btn-4" @click="switchModel(8, modelArr.b08.value)">
                <span class="zhileng" id="zhileng08">制冷</span>
                <span class="xiegang"> / </span>
                <span class="zhire" id="zhire08">制热</span>
              </div>
            </div>
          </div>

          <div class="screw-center-btn2">
            <div style="width: 85%;float: right;">
              <div class="screw-center-btn-1" @click="switchBeng(7, 1)">空调系统启动</div>
              <div class="screw-center-btn-2">
                <div class="screw-center-btn-2-1" id="xunhuanbeng07">循环泵</div>
                <div class="screw-center-btn-2-2" id="kongtiao07">空调</div>
              </div>
              <div class="screw-center-btn-3" @click="switchKong(7, 0)">空调系统关闭</div>
              <div class="screw-center-btn-4" @click="switchModel(7, modelArr.b07.value)">
                <span class="zhileng" id="zhileng07">制冷</span>
                <span class="xiegang"> / </span>
                <span class="zhire" id="zhire07">制热</span>
              </div>
            </div>
          </div>
        </div>

        <!-- F6-F5 -->
        <div class="screw-center-btn-all">
          <div class="screw-center-btn1">
            <div style="width: 85%;">
              <div class="screw-center-btn-1" @click="switchBeng(6, 1)">空调系统启动</div>
              <div class="screw-center-btn-2">
                <div class="screw-center-btn-2-1" id="xunhuanbeng06">循环泵</div>
                <div class="screw-center-btn-2-2" id="kongtiao06">空调</div>
              </div>
              <div class="screw-center-btn-3" @click="switchKong(6, 0)">空调系统关闭</div>
              <div class="screw-center-btn-4" @click="switchModel(6, modelArr.b06.value)">
                <span class="zhileng" id="zhileng06">制冷</span>
                <span class="xiegang"> / </span>
                <span class="zhire" id="zhire06">制热</span>
              </div>
            </div>
          </div>

          <div class="screw-center-btn2">
            <div style="width: 85%;float: right;">
              <div class="screw-center-btn-1" @click="switchBeng(5, 1)">空调系统启动</div>
              <div class="screw-center-btn-2">
                <div class="screw-center-btn-2-1" id="xunhuanbeng05">循环泵</div>
                <div class="screw-center-btn-2-2" id="kongtiao05">空调</div>
              </div>
              <div class="screw-center-btn-3" @click="switchKong(5, 0)">空调系统关闭</div>
              <div class="screw-center-btn-4" @click="switchModel(5, modelArr.b05.value)">
                <span class="zhileng" id="zhileng05">制冷</span>
                <span class="xiegang"> / </span>
                <span class="zhire" id="zhire05">制热</span>
              </div>
            </div>
          </div>
        </div>

        <!-- F3-F4 -->
        <div class="screw-center-btn-all">
          <div class="screw-center-btn1">
            <div style="width: 85%;">
              <div class="screw-center-btn-1" @click="switchBeng(4, 1)">空调系统启动</div>
              <div class="screw-center-btn-2">
                <div class="screw-center-btn-2-1" id="xunhuanbeng04">循环泵</div>
                <div class="screw-center-btn-2-2" id="kongtiao04">空调</div>
              </div>
              <div class="screw-center-btn-3" @click="switchKong(4, 0)">空调系统关闭</div>
              <div class="screw-center-btn-4" @click="switchModel(4, modelArr.b04.value)">
                <span class="zhileng" id="zhileng04">制冷</span>
                <span class="xiegang"> / </span>
                <span class="zhire" id="zhire04">制热</span>
              </div>
            </div>
          </div>

          <div class="screw-center-btn2">
            <div style="width: 85%;float: right;">
              <div class="screw-center-btn-1" @click="switchBeng(3, 1)">空调系统启动</div>
              <div class="screw-center-btn-2">
                <div class="screw-center-btn-2-1" id="xunhuanbeng03">循环泵</div>
                <div class="screw-center-btn-2-2" id="kongtiao03">空调</div>
              </div>
              <div class="screw-center-btn-3" @click="switchKong(3, 0)">空调系统关闭</div>
              <div class="screw-center-btn-4" @click="switchModel(3, modelArr.b03.value)">
                <span class="zhileng" id="zhileng03">制冷</span>
                <span class="xiegang"> / </span>
                <span class="zhire" id="zhire03">制热</span>
              </div>
            </div>
          </div>
        </div>

        <!-- F1-F2 -->
        <div class="screw-center-btn-all">
          <div class="screw-center-btn1">
            <div style="width: 85%;">
              <div class="screw-center-btn-1" @click="switchBeng(2, 1)">空调系统启动</div>
              <div class="screw-center-btn-2">
                <div class="screw-center-btn-2-1" id="xunhuanbeng02">循环泵</div>
                <div class="screw-center-btn-2-2" id="kongtiao02">空调</div>
              </div>
              <div class="screw-center-btn-3" @click="switchKong(2, 0)">空调系统关闭</div>
              <div class="screw-center-btn-4" @click="switchModel(2, modelArr.b02.value)">
                <span class="zhileng" id="zhileng02">制冷</span>
                <span class="xiegang"> / </span>
                <span class="zhire" id="zhire02">制热</span>
              </div>
            </div>
          </div>

          <div class="screw-center-btn2">
            <div style="width: 85%;float: right;">
              <div class="screw-center-btn-1" @click="switchBeng(1, 1)">空调系统启动</div>
              <div class="screw-center-btn-2">
                <div class="screw-center-btn-2-1" id="xunhuanbeng01">循环泵</div>
                <div class="screw-center-btn-2-2" id="kongtiao01">空调</div>
              </div>
              <div class="screw-center-btn-3" @click="switchKong(1, 0)">空调系统关闭</div>
              <div class="screw-center-btn-4" @click="switchModel(1, modelArr.b01.value)">
                <span class="zhileng" id="zhileng01">制冷</span>
                <span class="xiegang"> / </span>
                <span class="zhire" id="zhire01">制热</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="screw-center-titL">
          <span style="color: #28A1FE;">------</span> F10
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b10.value == 0" @click="switchBeng(10, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b10.value == 1" @click="switchBeng(10, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b10.value == 0" @click="switchKong(10, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b10.value == 1" @click="switchKong(10, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b10.value == 0" @click="switchModel(10, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b10.value == 1" @click="switchModel(10, 0)">制热 ☀</div>
        </div> -->
        <!-- <div class="screw-center-tit">
          F9 <span style="color: #28A1FE;">------</span>
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b09.value == 0" @click="switchBeng(9, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b09.value == 1" @click="switchBeng(9, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b09.value == 0" @click="switchKong(9, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b09.value == 1" @click="switchKong(9, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b09.value == 0" @click="switchModel(9, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b09.value == 1" @click="switchModel(9, 0)">制热 ☀</div>
        </div>
        <div class="screw-center-titL">
          <span style="color: #28A1FE;">------</span> F8
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b08.value == 0" @click="switchBeng(8, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b08.value == 1" @click="switchBeng(8, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b08.value == 0" @click="switchKong(8, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b08.value == 1" @click="switchKong(8, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b08.value == 0" @click="switchModel(8, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b08.value == 1" @click="switchModel(8, 0)">制热 ☀</div>
        </div>
        <div class="screw-center-tit">
          F7 <span style="color: #28A1FE;">------</span>
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b07.value == 0" @click="switchBeng(7, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b07.value == 1" @click="switchBeng(7, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b07.value == 0" @click="switchKong(7, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b07.value == 1" @click="switchKong(7, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b07.value == 0" @click="switchModel(7, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b07.value == 1" @click="switchModel(7, 0)">制热 ☀</div>
        </div>
        <div class="screw-center-titL">
          <span style="color: #28A1FE;">------</span> F6
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b06.value == 0" @click="switchBeng(6, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b06.value == 1" @click="switchBeng(6, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b06.value == 0" @click="switchKong(6, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b06.value == 1" @click="switchKong(6, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b06.value == 0" @click="switchModel(6, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b06.value == 1" @click="switchModel(6, 0)">制热 ☀</div>

        </div>
        <div class="screw-center-tit">
          F5 <span style="color: #28A1FE;">------</span>
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b05.value == 0" @click="switchBeng(5, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b05.value == 1" @click="switchBeng(5, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b05.value == 0" @click="switchKong(5, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b05.value == 1" @click="switchKong(5, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b05.value == 0" @click="switchModel(5, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b05.value == 1" @click="switchModel(5, 0)">制热 ☀</div>
        </div>
        <div class="screw-center-titL">
          <span style="color: #28A1FE;">------</span> F4
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b04.value == 0" @click="switchBeng(4, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b04.value == 1" @click="switchBeng(4, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b04.value == 0" @click="switchKong(4, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b04.value == 1" @click="switchKong(4, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b04.value == 0" @click="switchModel(4, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b04.value == 1" @click="switchModel(4, 0)">制热 ☀</div>
        </div>
        <div class="screw-center-tit">
          F3 <span style="color: #28A1FE;">------</span>
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b03.value == 0" @click="switchBeng(3, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b03.value == 1" @click="switchBeng(3, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b03.value == 0" @click="switchKong(3, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b03.value == 1" @click="switchKong(3, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b03.value == 0" @click="switchModel(3, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b03.value == 1" @click="switchModel(3, 0)">制热 ☀</div>
        </div>
        <div class="screw-center-titL">
          <span style="color: #28A1FE;">------</span> F2
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b02.value == 0" @click="switchBeng(2, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b02.value == 1" @click="switchBeng(2, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b02.value == 0" @click="switchKong(2, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b02.value == 1" @click="switchKong(2, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b02.value == 0" @click="switchModel(2, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b02.value == 1" @click="switchModel(2, 0)">制热 ☀</div>
        </div>
        <div class="screw-center-tit">
          F1 <span style="color: #28A1FE;">------</span>
        </div>
        <div class="screw-center-btn">
          <div class="screw-btn-box btn-on4" v-if="bengArr.b01.value == 0" @click="switchBeng(1, 1)">水泵</div>
          <div class="screw-btn-box btn-on1" v-if="bengArr.b01.value == 1" @click="switchBeng(1, 0)">水泵</div>
          <div class="screw-btn-box btn-on4" v-if="kongArr.b01.value == 0" @click="switchKong(1, 1)">空调</div>
          <div class="screw-btn-box btn-on1" v-if="kongArr.b01.value == 1" @click="switchKong(1, 0)">空调</div>
          <div class="screw-btn-box btn-on3" v-if="modelArr.b01.value == 0" @click="switchModel(1, 1)">制冷 ❉</div>
          <div class="screw-btn-box btn-on2" v-if="modelArr.b01.value == 1" @click="switchModel(1, 0)">制热 ☀</div>
        </div> -->
      </div>
      <div class="screw-body-inner-right">
        <div class="screw-right-main11">
          <div class="screw-left-main10-all">
            <div class="screw-left-main10-right">F11</div>
            <div class="screw-left-main10-left">功率曲线（单位：W）</div>
          </div>
          <div ref="pieEleven" style="width: 100%; height: 15vh"></div>
        </div>
        <div class="screw-right-main9">
          <div class="screw-left-main10-all">
            <div class="screw-left-main10-right">F9</div>
            <div class="screw-left-main10-left">功率曲线（单位：W）</div>
          </div>
          <div ref="pieNine" style="width: 100%; height: 15vh"></div>
        </div>
        <div class="screw-right-main7">
          <div class="screw-left-main10-all">
            <div class="screw-left-main10-right">F7</div>
            <div class="screw-left-main10-left">功率曲线（单位：W）</div>
          </div>
          <div ref="pieSeven" style="width: 100%; height: 15vh"></div>
        </div>
        <div class="screw-right-main5">
          <div class="screw-left-main10-all">
            <div class="screw-left-main10-right">F5</div>
            <div class="screw-left-main10-left">功率曲线（单位：W）</div>
          </div>
          <div ref="pieFive" style="width: 100%; height: 15vh"></div>
        </div>
        <div class="screw-right-main3">
          <div class="screw-left-main10-all">
            <div class="screw-left-main10-right">F3</div>
            <div class="screw-left-main10-left">功率曲线（单位：W）</div>
          </div>
          <div ref="pieThree" style="width: 100%; height: 15vh"></div>
        </div>
        <div class="screw-right-main1">
          <div class="screw-left-main10-all">
            <div class="screw-left-main10-right">F1</div>
            <div class="screw-left-main10-left">功率曲线（单位：W）</div>
          </div>
          <div ref="pieOne" style="width: 100%; height: 15vh"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import * as echarts from 'echarts';
import echarts from 'echarts';
import service from '../../service/leftService';
export default {
  name: '',
  props: [''],
  data() {
    return {
      homeTime: "",
      temp: '',
      testArray: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',],
      testSize: 0,
      xData1: [],
      xData2: [],
      xData3: [],
      xData4: [],
      xData5: [],
      xData6: [],
      xData7: [],
      xData8: [],
      xData9: [],
      xData10: [],
      xData11: [],
      timer: null,
      timmer: null,
      bengArr: {
        b01: {
          id: '',
          value: 0,
        },
        b02: {
          id: '',
          value: '0',
        },
        b03: {
          id: '',
          value: '0',
        },
        b04: {
          id: '',
          value: '0',
        },
        b05: {
          id: '',
          value: '0',
        },
        b06: {
          id: '',
          value: '0',
        },
        b07: {
          id: '',
          value: '0',
        },
        b08: {
          id: '',
          value: '0',
        },
        b09: {
          id: '',
          value: '0',
        },
        b10: {
          id: '',
          value: '0',
        },
        b11: {
          id: '',
          value: '0',
        },
      },
      kongArr: {
        b01: {
          id: '',
          value: 0,
        },
        b02: {
          id: '',
          value: '0',
        },
        b03: {
          id: '',
          value: '0',
        },
        b04: {
          id: '',
          value: '0',
        },
        b05: {
          id: '',
          value: '0',
        },
        b06: {
          id: '',
          value: '0',
        },
        b07: {
          id: '',
          value: '0',
        },
        b08: {
          id: '',
          value: '0',
        },
        b09: {
          id: '',
          value: '0',
        },
        b10: {
          id: '',
          value: '0',
        },
        b11: {
          id: '',
          value: '0',
        },
      },
      modelArr: {
        b01: {
          id: '',
          value: 0,
        },
        b02: {
          id: '',
          value: '0',
        },
        b03: {
          id: '',
          value: '0',
        },
        b04: {
          id: '',
          value: '0',
        },
        b05: {
          id: '',
          value: '0',
        },
        b06: {
          id: '',
          value: '0',
        },
        b07: {
          id: '',
          value: '0',
        },
        b08: {
          id: '',
          value: '0',
        },
        b09: {
          id: '',
          value: '0',
        },
        b10: {
          id: '',
          value: '0',
        },
        b11: {
          id: '',
          value: '0',
        },
      },
      weather: "",
    };
  },

  components: {},

  computed: {},

  beforeMount() { },

  methods: {
    // 开启空调改变颜色
    /*  start() {
       //空调启动
       setTimeout(function () {
         document.getElementById('startkt').style.backgroundColor = '#39C70E';
         document.getElementById('startkt').style.color = '#38444A';
       }, 1000);
       // 循环泵开启
       setTimeout(function () {
         document.getElementById('xunhuan').style.backgroundColor = '#39C70E';
         document.getElementById('xunhuan').style.color = '#38444A';
       }, 1000);
       // 空调开启
       setTimeout(function () {
         document.getElementById('kongtiao').style.backgroundColor = '#39C70E';
       }, 10000);
     }, */

    // 关闭空调改变颜色
    /* encode() {
      //空调关闭
      setTimeout(function () {
        document.getElementById('startkt').style.backgroundColor = '#38444A';
        document.getElementById('startkt').style.color = '#39C70E';
      }, 10000);
      // 循环泵关闭 
      setTimeout(function () {
        document.getElementById('xunhuan').style.backgroundColor = '#38444A';
        document.getElementById('xunhuan').style.color = '#39C70E';
      }, 10000);
      // 空调关闭
      setTimeout(function () {
        document.getElementById('kongtiao').style.backgroundColor = '#7B99D5';
      }, 1000);
    }, */

    echartsInit() {
      // 获取当前时间戳
      let timestamp = Date.now();
      // F10
      let pieTen = echarts.init(this.$refs.pieTen);
      pieTen.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '10%',
            bottom: '28%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData10,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#89BBED', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#4B6181'
                  },
                  {
                    offset: 1,
                    color: '#4b618142'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieTen.resize()
      })
      // F8
      let pieEight = echarts.init(this.$refs.pieEight);
      pieEight.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '10%',
            bottom: '28%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData8,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#89BBED', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#4B6181'
                  },
                  {
                    offset: 1,
                    color: '#4b618142'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieEight.resize()
      })
      // F6
      let pieSix = echarts.init(this.$refs.pieSix);
      pieSix.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '10%',
            bottom: '28%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData6,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#89BBED', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#4B6181'
                  },
                  {
                    offset: 1,
                    color: '#4b618142'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieSix.resize()
      })
      // F4
      let pieFour = echarts.init(this.$refs.pieFour);
      pieFour.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '10%',
            bottom: '28%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData4,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#89BBED', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#4B6181'
                  },
                  {
                    offset: 1,
                    color: '#4b618142'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieFour.resize()
      })
      // F2
      let pieTwo = echarts.init(this.$refs.pieTwo);
      pieTwo.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '10%',
            bottom: '28%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData2,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#89BBED', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#4B6181'
                  },
                  {
                    offset: 1,
                    color: '#4b618142'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieTwo.resize()
      })
      // F11
      let pieEleven = echarts.init(this.$refs.pieEleven);
      pieEleven.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '10%',
            bottom: '15%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData11,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#89BBED', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#4B6181'
                  },
                  {
                    offset: 1,
                    color: '#4b618142'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieEleven.resize()
      })
      // F9
      let pieNine = echarts.init(this.$refs.pieNine);
      pieNine.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '10%',
            bottom: '15%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData9,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#89BBED', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#4B6181'
                  },
                  {
                    offset: 1,
                    color: '#4b618142'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieNine.resize()
      })
      // F7
      let pieSeven = echarts.init(this.$refs.pieSeven);
      pieSeven.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '10%',
            bottom: '15%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData7,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#89BBED', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#4B6181'
                  },
                  {
                    offset: 1,
                    color: '#4b618142'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieSeven.resize()
      })
      // F5
      let pieFive = echarts.init(this.$refs.pieFive);
      pieFive.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '10%',
            bottom: '15%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData5,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#89BBED', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#4B6181'
                  },
                  {
                    offset: 1,
                    color: '#4b618142'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieFive.resize()
      })
      // F3
      let pieThree = echarts.init(this.$refs.pieThree);
      pieThree.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '8%',
            bottom: '18%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData3,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#89BBED', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#4B6181'
                  },
                  {
                    offset: 1,
                    color: '#4b618142'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieThree.resize()
      })
      // F1
      let pieOne = echarts.init(this.$refs.pieOne);
      pieOne.setOption(
        {
          grid: {
            left: '2%',
            right: '2%',
            top: '10%',
            bottom: '15%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: { // X轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变X轴颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // Y轴线的样式
              lineStyle: {
                color: '#4F78A7' // 改变Y轴颜色为蓝色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#1a3a61' // 虚线颜色
              }
            }
          },
          series: [
            {
              data: this.xData1,
              type: 'line',
              symbol: 'none', // 设置为 'none' 去掉折点小圆
              lineStyle: {
                color: '#89BBED', // 这里设置为黄色
                width: 1, // 设置线宽
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#4B6181'
                  },
                  {
                    offset: 1,
                    color: '#4b618142'
                  }
                  ], false),
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieOne.resize()
      })
    },

    getTime() {
      let myDate = new Date();
      let year = myDate.getFullYear();
      let month = myDate.getMonth() + 1;
      let day = myDate.getDate();
      let house = myDate.getHours();
      let minutes = myDate.getMinutes();
      let second = myDate.getSeconds();
      let time = house + ":" + minutes + ":" + second;
      this.homeTime = year + '-' + month + '-' + day + ' ' + house + ':' + minutes + ':' + second;
      let obj = {
        "args": ['上海城工功率数据接口']
      }
      service.getPublicData(obj).then(res => {
        if (this.testSize > 900) {
          this.testSize = 920
          this.testArray.shift()
          this.testArray.push(time)
        } else {
          this.testArray.splice(this.testSize, 1, time)
        }
        res.forEach(item => {
          if (item.secondName == 'SHCG_P01') {
            if (this.testSize > 900) {
              this.xData1.shift()
              this.xData1.push(item.value)
            } else {
              this.xData1.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P02') {
            if (this.testSize > 900) {
              this.xData2.shift()
              this.xData2.push(item.value)
            } else {
              this.xData2.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P03') {
            if (this.testSize > 900) {
              this.xData3.shift()
              this.xData3.push(item.value)
            } else {
              this.xData3.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P04') {
            if (this.testSize > 900) {
              this.xData4.shift()
              this.xData4.push(item.value)
            } else {
              this.xData4.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P05') {
            if (this.testSize > 900) {
              this.xData5.shift()
              this.xData5.push(item.value)
            } else {
              this.xData5.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P06') {
            if (this.testSize > 900) {
              this.xData6.shift()
              this.xData6.push(item.value)
            } else {
              this.xData6.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P07') {
            if (this.testSize > 900) {
              this.xData7.shift()
              this.xData7.push(item.value)
            } else {
              this.xData7.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P08') {
            if (this.testSize > 900) {
              this.xData8.shift()
              this.xData8.push(item.value)
            } else {
              this.xData8.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P09') {
            if (this.testSize > 900) {
              this.xData9.shift()
              this.xData9.push(item.value)
            } else {
              this.xData9.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P10') {
            if (this.testSize > 900) {
              this.xData10.shift()
              this.xData10.push(item.value)
            } else {
              this.xData10.push(item.value)
            }
          }
          if (item.secondName == 'SHCG_P11') {
            if (this.testSize > 900) {
              this.xData11.shift()
              this.xData11.push(item.value)
            } else {
              this.xData11.push(item.value)
            }
          }
        });
        this.testSize++
        this.echartsInit()
      })
    },
    // 获取循环泵数据
    getData() {
      // 获取循环泵开关数据
      let obj = {
        "args": ['上海城工循环泵开关']
      }
      service.getPublicData(obj).then(res => {
        res.forEach(item => {
          if (item.secondName == 'SHCG_B01') {
            this.bengArr.b01.id = item.id
            if (item.value == 1) {
              this.bengArr.b01.value = 1
              document.getElementById('xunhuanbeng01').style.backgroundColor = '#32B623';
            } else {
              this.bengArr.b01.value = 0
              document.getElementById('xunhuanbeng01').style.backgroundColor = '#D92323';
            }
          }
          if (item.secondName == 'SHCG_B02') {
            this.bengArr.b02.id = item.id
            if (item.value == 1) {
              this.bengArr.b02.value = 1
              document.getElementById('xunhuanbeng02').style.backgroundColor = '#32B623';
            } else {
              this.bengArr.b02.value = 0
              document.getElementById('xunhuanbeng02').style.backgroundColor = '#D92323';
            }
          }
          if (item.secondName == 'SHCG_B03') {
            this.bengArr.b03.id = item.id
            if (item.value == 1) {
              this.bengArr.b03.value = 1
              document.getElementById('xunhuanbeng03').style.backgroundColor = '#32B623';
            } else {
              this.bengArr.b03.value = 0
              document.getElementById('xunhuanbeng03').style.backgroundColor = '#D92323';
            }
          }
          if (item.secondName == 'SHCG_B04') {
            this.bengArr.b04.id = item.id
            if (item.value == 1) {
              this.bengArr.b04.value = 1
              document.getElementById('xunhuanbeng04').style.backgroundColor = '#32B623';
            } else {
              this.bengArr.b04.value = 0
              document.getElementById('xunhuanbeng04').style.backgroundColor = '#D92323';
            }
          }
          if (item.secondName == 'SHCG_B05') {
            this.bengArr.b05.id = item.id
            if (item.value == 1) {
              this.bengArr.b05.value = 1
              document.getElementById('xunhuanbeng05').style.backgroundColor = '#32B623';
            } else {
              this.bengArr.b05.value = 0
              document.getElementById('xunhuanbeng05').style.backgroundColor = '#D92323';
            }
          }
          if (item.secondName == 'SHCG_B06') {
            this.bengArr.b06.id = item.id
            if (item.value == 1) {
              this.bengArr.b06.value = 1
              document.getElementById('xunhuanbeng06').style.backgroundColor = '#32B623';
            } else {
              this.bengArr.b06.value = 0
              document.getElementById('xunhuanbeng06').style.backgroundColor = '#D92323';
            }
          }
          if (item.secondName == 'SHCG_B07') {
            this.bengArr.b07.id = item.id
            if (item.value == 1) {
              this.bengArr.b07.value = 1
              document.getElementById('xunhuanbeng07').style.backgroundColor = '#32B623';
            } else {
              this.bengArr.b07.value = 0
              document.getElementById('xunhuanbeng07').style.backgroundColor = '#D92323';
            }
          }
          if (item.secondName == 'SHCG_B08') {
            this.bengArr.b08.id = item.id
            if (item.value == 1) {
              this.bengArr.b08.value = 1
              document.getElementById('xunhuanbeng08').style.backgroundColor = '#32B623';
            } else {
              this.bengArr.b08.value = 0
              document.getElementById('xunhuanbeng08').style.backgroundColor = '#D92323';
            }
          }
          if (item.secondName == 'SHCG_B09') {
            this.bengArr.b09.id = item.id
            if (item.value == 1) {
              this.bengArr.b09.value = 1
              document.getElementById('xunhuanbeng09').style.backgroundColor = '#32B623';
            } else {
              this.bengArr.b09.value = 0
              document.getElementById('xunhuanbeng09').style.backgroundColor = '#D92323';
            }
          }
          if (item.secondName == 'SHCG_B10') {
            this.bengArr.b10.id = item.id
            if (item.value == 1) {
              this.bengArr.b10.value = 1
              document.getElementById('xunhuanbeng10').style.backgroundColor = '#32B623';
            } else {
              this.bengArr.b10.value = 0
              document.getElementById('xunhuanbeng10').style.backgroundColor = '#D92323';
            }
          }
          if (item.secondName == 'SHCG_B11') {
            this.bengArr.b11.id = item.id
            if (item.value == 1) {
              this.bengArr.b11.value = 1
              document.getElementById('xunhuanbeng11').style.backgroundColor = '#32B623';
            } else {
              this.bengArr.b11.value = 0
              document.getElementById('xunhuanbeng11').style.backgroundColor = '#D92323';
            }
          }

        })
      })
    },
    // 空调数据接口
    getDataKong() {
      let obj = {
        "args": ['上海城工空调数据接口']
      }
      service.getPublicData(obj).then(res => {
        res.forEach(item => {
          if (item.secondName == 'SHCG_K01') {
            this.kongArr.b01.id = item.id
            if (item.value == 1) {
              this.kongArr.b01.value = 1
              document.getElementById('kongtiao01').style.backgroundColor = '#32B623';
            } else {
              this.kongArr.b01.value = 0
              document.getElementById('kongtiao01').style.backgroundColor = '#D92323';
            }
          }
          if (item.secondName == 'SHCG_K02') {
            this.kongArr.b02.id = item.id
            if (item.value == 1) {
              this.kongArr.b02.value = 1
              document.getElementById('kongtiao02').style.backgroundColor = '#32B623';
            } else {
              this.kongArr.b02.value = 0
              document.getElementById('kongtiao02').style.backgroundColor = '#D92323';
            }
          }
          if (item.secondName == 'SHCG_K03') {
            this.kongArr.b03.id = item.id
            if (item.value == 1) {
              this.kongArr.b03.value = 1
              document.getElementById('kongtiao03').style.backgroundColor = '#32B623';
            } else {
              this.kongArr.b03.value = 0
              document.getElementById('kongtiao03').style.backgroundColor = '#D92323';
            }
          }
          if (item.secondName == 'SHCG_K04') {
            this.kongArr.b04.id = item.id
            if (item.value == 1) {
              this.kongArr.b04.value = 1
              document.getElementById('kongtiao04').style.backgroundColor = '#FFFF00';
            } else {
              this.kongArr.b04.value = 0
              document.getElementById('kongtiao04').style.backgroundColor = '#FFFF00';
            }
          }
          if (item.secondName == 'SHCG_K05') {
            this.kongArr.b05.id = item.id
            if (item.value == 1) {
              this.kongArr.b05.value = 1
              document.getElementById('kongtiao05').style.backgroundColor = '#32B623';

            } else {
              this.kongArr.b05.value = 0
              document.getElementById('kongtiao05').style.backgroundColor = '#D92323';

            }
          }
          if (item.secondName == 'SHCG_K06') {
            this.kongArr.b06.id = item.id
            if (item.value == 1) {
              this.kongArr.b06.value = 1
              document.getElementById('kongtiao06').style.backgroundColor = '#32B623';

            } else {
              this.kongArr.b06.value = 0
              document.getElementById('kongtiao06').style.backgroundColor = '#D92323';

            }
          }
          if (item.secondName == 'SHCG_K07') {
            this.kongArr.b07.id = item.id
            if (item.value == 1) {
              this.kongArr.b07.value = 1
              document.getElementById('kongtiao07').style.backgroundColor = '#32B623';

            } else {
              this.kongArr.b07.value = 0
              document.getElementById('kongtiao07').style.backgroundColor = '#D92323';

            }
          }
          if (item.secondName == 'SHCG_K08') {
            this.kongArr.b08.id = item.id
            if (item.value == 1) {
              this.kongArr.b08.value = 1
              document.getElementById('kongtiao08').style.backgroundColor = '#32B623';

            } else {
              this.kongArr.b08.value = 0
              document.getElementById('kongtiao08').style.backgroundColor = '#D92323';

            }
          }
          if (item.secondName == 'SHCG_K09') {
            this.kongArr.b09.id = item.id
            if (item.value == 1) {
              this.kongArr.b09.value = 1
              document.getElementById('kongtiao09').style.backgroundColor = '#32B623';

            } else {
              this.kongArr.b09.value = 0
              document.getElementById('kongtiao09').style.backgroundColor = '#D92323';

            }
          }
          if (item.secondName == 'SHCG_K10') {
            this.kongArr.b10.id = item.id
            if (item.value == 1) {
              this.kongArr.b10.value = 1
              document.getElementById('kongtiao10').style.backgroundColor = '#32B623';

            } else {
              this.kongArr.b10.value = 0
              document.getElementById('kongtiao10').style.backgroundColor = '#D92323';

            }
          }
          if (item.secondName == 'SHCG_K11') {
            this.kongArr.b11.id = item.id
            if (item.value == 1) {
              this.kongArr.b11.value = 1
              document.getElementById('kongtiao11').style.backgroundColor = '#32B623';

            } else {
              this.kongArr.b11.value = 0
              document.getElementById('kongtiao11').style.backgroundColor = '#D92323';

            }
          }

        })
      })
    },
    // 模式数据接口
    getDataModel() {
      let obj = {
        "args": ['上海城工模式数据接口']
      }
      service.getPublicData(obj).then(res => {
        res.forEach(item => {
          if (item.secondName == 'SHCG_M01') {
            this.modelArr.b01.id = item.id
            if (item.value == 1) {
              this.modelArr.b01.value = 1
              document.getElementById('zhire01').style.color = '#B64229';
              document.getElementById('zhileng01').style.color = '#667494';
            } else {
              this.modelArr.b01.value = 0
              document.getElementById('zhire01').style.color = '#667494';
              document.getElementById('zhileng01').style.color = '#2284ca';
            }
          }
          if (item.secondName == 'SHCG_M02') {
            this.modelArr.b02.id = item.id
            if (item.value == 1) {
              this.modelArr.b02.value = 1
              document.getElementById('zhire02').style.color = '#B64229';
              document.getElementById('zhileng02').style.color = '#667494';
            } else {
              this.modelArr.b02.value = 0
              document.getElementById('zhire02').style.color = '#667494';
              document.getElementById('zhileng02').style.color = '#2284ca';
            }
          }
          if (item.secondName == 'SHCG_M03') {
            this.modelArr.b03.id = item.id
            if (item.value == 1) {
              this.modelArr.b03.value = 1
              document.getElementById('zhire03').style.color = '#B64229';
              document.getElementById('zhileng03').style.color = '#667494';
            } else {
              this.modelArr.b03.value = 0
              document.getElementById('zhire03').style.color = '#667494';
              document.getElementById('zhileng03').style.color = '#2284ca';
            }
          }
          if (item.secondName == 'SHCG_M04') {
            this.modelArr.b04.id = item.id
            if (item.value == 1) {
              this.modelArr.b04.value = 1
              document.getElementById('zhire04').style.color = '#DCCD79';
              document.getElementById('zhileng04').style.color = '#DCCD79';
            } else {
              this.modelArr.b04.value = 0
              document.getElementById('zhire04').style.color = '#667494';
              document.getElementById('zhileng04').style.color = '#2284ca';
            }
          }
          if (item.secondName == 'SHCG_M05') {
            this.modelArr.b05.id = item.id
            if (item.value == 1) {
              this.modelArr.b05.value = 1
              document.getElementById('zhire05').style.color = '#B64229';
              document.getElementById('zhileng05').style.color = '#667494';
            } else {
              this.modelArr.b05.value = 0
              document.getElementById('zhire05').style.color = '#667494';
              document.getElementById('zhileng05').style.color = '#2284ca';
            }
          }
          if (item.secondName == 'SHCG_M06') {
            this.modelArr.b06.id = item.id
            if (item.value == 1) {
              this.modelArr.b06.value = 1
              document.getElementById('zhire06').style.color = '#B64229';
              document.getElementById('zhileng06').style.color = '#667494';
            } else {
              this.modelArr.b06.value = 0
              document.getElementById('zhire06').style.color = '#667494';
              document.getElementById('zhileng06').style.color = '#2284ca';
            }
          }
          if (item.secondName == 'SHCG_M07') {
            this.modelArr.b07.id = item.id
            if (item.value == 1) {
              this.modelArr.b07.value = 1
              document.getElementById('zhire07').style.color = '#B64229';
              document.getElementById('zhileng07').style.color = '#667494';
            } else {
              this.modelArr.b07.value = 0
              document.getElementById('zhire07').style.color = '#667494';
              document.getElementById('zhileng07').style.color = '#2284ca';
            }
          }
          if (item.secondName == 'SHCG_M08') {
            this.modelArr.b08.id = item.id
            if (item.value == 1) {
              this.modelArr.b08.value = 1
              document.getElementById('zhire08').style.color = '#B64229';
              document.getElementById('zhileng08').style.color = '#667494';
            } else {
              this.modelArr.b08.value = 0
              document.getElementById('zhire08').style.color = '#667494';
              document.getElementById('zhileng08').style.color = '#2284ca';
            }
          }
          if (item.secondName == 'SHCG_M09') {
            this.modelArr.b09.id = item.id
            if (item.value == 1) {
              this.modelArr.b09.value = 1
              document.getElementById('zhire09').style.color = '#B64229';
              document.getElementById('zhileng09').style.color = '#667494';
            } else {
              this.modelArr.b09.value = 0
              document.getElementById('zhire09').style.color = '#667494';
              document.getElementById('zhileng09').style.color = '#2284ca';
            }
          }
          if (item.secondName == 'SHCG_M10') {
            this.modelArr.b10.id = item.id
            if (item.value == 1) {
              this.modelArr.b10.value = 1
              document.getElementById('zhire10').style.color = '#B64229';
              document.getElementById('zhileng10').style.color = '#667494';
            } else {
              this.modelArr.b10.value = 0
              document.getElementById('zhire10').style.color = '#667494';
              document.getElementById('zhileng10').style.color = '#2284ca';
            }
          }
          if (item.secondName == 'SHCG_M11') {
            this.modelArr.b11.id = item.id
            if (item.value == 1) {
              this.modelArr.b11.value = 1
              document.getElementById('zhire11').style.color = '#B64229';
              document.getElementById('zhileng11').style.color = '#667494';
            } else {
              this.modelArr.b11.value = 0
              document.getElementById('zhire11').style.color = '#667494';
              document.getElementById('zhileng11').style.color = '#2284ca';
            }
          }

        })
      })
    },
    // 水泵开关
    switchBeng(h, val) {
      if (h == 1) {
        this.bengArr.b01.value = val
        this.updateData(this.bengArr.b01)
      }
      if (h == 2) {
        this.bengArr.b02.value = val
        this.updateData(this.bengArr.b02)
      }
      if (h == 3) {
        this.bengArr.b03.value = val
        this.updateData(this.bengArr.b03)
      }
      if (h == 4) {
        this.bengArr.b04.value = val
        this.updateData(this.bengArr.b04)
      }
      if (h == 5) {
        this.bengArr.b05.value = val
        this.updateData(this.bengArr.b05)
      }
      if (h == 6) {
        this.bengArr.b06.value = val
        this.updateData(this.bengArr.b06)
      }
      if (h == 7) {
        this.bengArr.b07.value = val
        this.updateData(this.bengArr.b07)
      }
      if (h == 8) {
        this.bengArr.b08.value = val
        this.updateData(this.bengArr.b08)
      }
      if (h == 9) {
        this.bengArr.b09.value = val
        this.updateData(this.bengArr.b09)
      }
      if (h == 10) {
        this.bengArr.b10.value = val
        this.updateData(this.bengArr.b10)
      }
      if (h == 11) {
        this.bengArr.b11.value = val
        this.updateData(this.bengArr.b11)
      }
    },
    // 空调开关切换
    switchKong(h, val) {
      if (h == 1) {
        this.kongArr.b01.value = val
        this.updateData(this.kongArr.b01)
      }
      if (h == 2) {
        this.kongArr.b02.value = val
        this.updateData(this.kongArr.b02)
      }
      if (h == 3) {
        this.kongArr.b03.value = val
        this.updateData(this.kongArr.b03)
      }
      if (h == 4) {
        this.kongArr.b04.value = val
        this.updateData(this.kongArr.b04)
      }
      if (h == 5) {
        this.kongArr.b05.value = val
        this.updateData(this.kongArr.b05)
      }
      if (h == 6) {
        this.kongArr.b06.value = val
        this.updateData(this.kongArr.b06)
      }
      if (h == 7) {
        this.kongArr.b07.value = val
        this.updateData(this.kongArr.b07)
      }
      if (h == 8) {
        this.kongArr.b08.value = val
        this.updateData(this.kongArr.b08)
      }
      if (h == 9) {
        this.kongArr.b09.value = val
        this.updateData(this.kongArr.b09)
      }
      if (h == 10) {
        this.kongArr.b10.value = val
        this.updateData(this.kongArr.b10)
      }
      if (h == 11) {
        this.kongArr.b11.value = val
        this.updateData(this.kongArr.b11)
      }
    },
    // 模式开关切换
    switchModel(h, val) {
      if (val == 1) {
        val = 0
      } else {
        val = 1
      }
      if (h == 1) {
        this.modelArr.b01.value = val
        this.updateData(this.modelArr.b01)
      }
      if (h == 2) {
        this.modelArr.b02.value = val
        this.updateData(this.modelArr.b02)
      }
      if (h == 3) {
        this.modelArr.b03.value = val
        this.updateData(this.modelArr.b03)
      }
      if (h == 4) {
        this.modelArr.b04.value = val
        this.updateData(this.modelArr.b04)
      }
      if (h == 5) {
        this.modelArr.b05.value = val
        this.updateData(this.modelArr.b05)
      }
      if (h == 6) {
        this.modelArr.b06.value = val
        this.updateData(this.modelArr.b06)
      }
      if (h == 7) {
        this.modelArr.b07.value = val
        this.updateData(this.modelArr.b07)
      }
      if (h == 8) {
        this.modelArr.b08.value = val
        this.updateData(this.modelArr.b08)
      }
      if (h == 9) {
        this.modelArr.b09.value = val
        this.updateData(this.modelArr.b09)
      }
      if (h == 10) {
        this.modelArr.b10.value = val
        this.updateData(this.modelArr.b10)
      }
      if (h == 11) {
        this.modelArr.b11.value = val
        this.updateData(this.modelArr.b11)
      }
    },
    // 修改数据
    updateData(obj) {
      service.updatePhysicalPoint(obj).then(res => {
        this.$message.success('切换成功')
      }).catch(err => {
        this.$message.error('切换失败')
      })
    },
    hefeng() {
      return new Promise((resovle, reject) => {
        $.ajax({
          type: 'GET',
          url: 'https://devapi.qweather.com/v7/weather/now?location=101190101&key=cb8885d03abc4412ab83212e87a4fddf',
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          success: (data) => {
            this.temp = data.now.temp
            this.weather = data.now.text
          },
          erroe: (err) => {
            console.log(err)
          }
        })
      })
    },
  },

  watch: {},

  mounted() {
    this.timer = setInterval(() => {
      this.getTime()
    }, 1000)
    this.timer1 = setInterval(() => {
      this.getData()
    }, 1000)
    this.timer2 = setInterval(() => {
      this.getDataKong()
    }, 1000)
    this.timer2 = setInterval(() => {
      this.getDataModel()
    }, 1000)
    this.hefeng()
  },

  destroyed() {
    clearInterval(this.timer)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}

</script>
<style lang='scss' scoped>
.screw-body {
  width: 100%;
  height: 100%;
  // background: url('../../../static/img/sicon/screw001.png') no-repeat;
  background-color: #11151E;
  background-size: 100% 100%;
  overflow: hidden;

  .screw-body-inner {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .screw-body-inner-left {
      width: 43%;
      height: 100%;

      .screw-left-logo {
        // width: 100%;
        // height: 7.5vh;
        // background-image: url('../../../static/img/sicon/screw002.png');
        // background-size: 100% 100%;
        width: 100%;
        height: 16.5vh;
        // background: #006effb1;
        display: flex;
      }

      .screw-left-logo-img {
        width: 40%;
        height: 100%;
        // background-color: #FFFFFF;
        padding-left: 6vh;
        padding-top: 2vh;
      }

      .screw-left-logo-text {
        padding-left: 2.5vh;
        padding-top: 1.5vh;
      }

      .text1 {
        color: #779DCE;
        font-size: 2.3vh;
        font-weight: 800;
        padding-top: 1vh;
      }

      .text2 {
        color: #779DCE;
        font-size: 1.7vh;
        font-weight: 700;
        padding-top: 1.0vh;
      }

      .text3 {
        color: #779DCE;
        font-size: 1.5vh;
        font-weight: 700;
        padding-top: 1vh;
      }

      .screw-left-body {
        width: 100%;
        height: calc(100% - 15.5vh);
        box-sizing: border-box;
        padding-left: 5vh;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-wrap: wrap;
        overflow: hidden;

        .screw-left-main10 {
          width: 100%;
          height: 16vh;
          background-image: url('../../../static/img/sicon/screw10.png');
          background-size: 100% 100%;

          .screw-left-main10-all {
            width: 100%;
            height: 3vh;
            display: flex;
            padding: 0 8vh 0 8vh;
            align-items: center;
            justify-content: space-between;
          }

          .screw-left-main10-left {
            font-size: 1.8vh;
            font-weight: 900;
            color: #8ABCF4;
          }

          .screw-left-main10-right {
            font-size: 2vh;
            font-weight: 800;
            color: #8ABCF4;
          }
        }

        .screw-left-main8 {
          width: 100%;
          height: 16vh;
          background-image: url('../../../static/img/sicon/screw10.png');
          background-size: 100% 100%;

          .screw-left-main10-all {
            width: 100%;
            height: 3vh;
            display: flex;
            padding: 0 8vh 0 8vh;
            align-items: center;
            justify-content: space-between;
          }

          .screw-left-main10-left {
            font-size: 1.8vh;
            font-weight: 900;
            color: #8ABCF4;
          }

          .screw-left-main10-right {
            font-size: 2vh;
            font-weight: 800;
            color: #8ABCF4;
          }
        }

        .screw-left-main6 {
          width: 100%;
          height: 16vh;
          background-image: url('../../../static/img/sicon/screw10.png');
          background-size: 100% 100%;

          .screw-left-main10-all {
            width: 100%;
            height: 3vh;
            display: flex;
            padding: 0 8vh 0 8vh;
            align-items: center;
            justify-content: space-between;
          }

          .screw-left-main10-left {
            font-size: 1.8vh;
            font-weight: 900;
            color: #8ABCF4;
          }

          .screw-left-main10-right {
            font-size: 2vh;
            font-weight: 800;
            color: #8ABCF4;
          }
        }

        .screw-left-main4 {
          width: 100%;
          height: 16vh;
          background-image: url('../../../static/img/sicon/screw10.png');
          background-size: 100% 100%;

          .screw-left-main10-all {
            width: 100%;
            height: 3vh;
            display: flex;
            padding: 0 8vh 0 8vh;
            align-items: center;
            justify-content: space-between;
          }

          .screw-left-main10-left {
            font-size: 1.8vh;
            font-weight: 900;
            color: #8ABCF4;
          }

          .screw-left-main10-right {
            font-size: 2vh;
            font-weight: 800;
            color: #8ABCF4;
          }
        }

        .screw-left-main2 {
          width: 100%;
          height: 16vh;
          background-image: url('../../../static/img/sicon/screw10.png');
          background-size: 100% 100%;

          .screw-left-main10-all {
            width: 100%;
            height: 3vh;
            display: flex;
            padding: 0 8vh 0 8vh;
            align-items: center;
            justify-content: space-between;
          }

          .screw-left-main10-left {
            font-size: 1.8vh;
            font-weight: 900;
            color: #8ABCF4;
          }

          .screw-left-main10-right {
            font-size: 2vh;
            font-weight: 800;
            color: #8ABCF4;
          }
        }
      }
    }

    .screw-body-inner-center {
      width: 11%;
      height: 100%;
      box-sizing: border-box;
      padding: 8px 0px 0px 0px;

      .screw-center-tit {
        width: 100%;
        height: 3vh;
        text-align: right;
        color: #FFFFFF;
        font-size: 1.5vh;
        font-weight: 800;
      }

      .screw-center-titL {
        width: 100%;
        height: 3vh;
        text-align: left;
        color: #FFFFFF;
        font-size: 1.5vh;
        font-weight: 800;
      }

      .screw-center-btn-all {
        width: 100%;
        height: 17vh;
        margin-top: 0.3vh;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // text-align: right;
        position: relative;
        box-sizing: border-box;
      }

      .screw-center-btn1 {
        width: 100%;
        height: 17vh;
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
        // text-align: right;
        // position: relative;
        box-sizing: border-box;
        // padding: 0px 20px 0px 20px;

        .screw-center-btn-1 {
          height: 2.5vh;
          background-color: #017501da;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          color: #11151E;
          font-weight: 800;
          font-size: 1.3vh;
          cursor: pointer;
        }

        .screw-center-btn-1:active {
          background-color: #32b623;
        }

        .screw-center-btn-2 {
          margin-top: 0.5vh;
          height: 3vh;
          // background-color: #779DCE;
          display: flex;
          justify-content: space-between;
        }

        .screw-center-btn-2-1 {
          width: 42%;
          height: 2.5vh;
          background-color: #FFFF00;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          font-weight: 800;
          font-size: 1.2vh;
          color: #11151E;
          cursor: pointer;
        }

        .screw-center-btn-2-2 {
          width: 42%;
          height: 2.5vh;
          background-color: #FFFF00;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          font-weight: 800;
          font-size: 1.2vh;
          color: #11151E;
          cursor: pointer;
        }

        .screw-center-btn-3 {
          margin-top: 0.5vh;
          height: 2.5vh;
          background-color: #a21e1e;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          color: #11151E;
          font-weight: 800;
          font-size: 1.3vh;
          cursor: pointer;
        }

        .screw-center-btn-3:active {
          background-color: #e92525;
        }

        .screw-center-btn-4 {
          margin-top: 1vh;
          height: 2.5vh;
          background-color: #7B99D5;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          font-weight: 800;
          font-size: 1.3vh;
        }

        .zhileng {
          color: #FFFF00;
          cursor: pointer;
        }

        .xiegang {
          color: #777D81;
        }

        .zhire {
          color: #FFFF00;
          cursor: pointer;
        }
      }

      .screw-center-btn2 {
        width: 100%;
        height: 17vh;
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
        // text-align: right;
        // position: relative;
        box-sizing: border-box;
        // padding: 0px 20px 0px 20px;

        .screw-center-btn-1 {
          height: 2.5vh;
          background-color: #265e20;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          color: #11151E;
          font-weight: 800;
          font-size: 1.3vh;
          cursor: pointer;
        }

        .screw-center-btn-1:active {
          background-color: #32b623;
        }

        .screw-center-btn-2 {
          margin-top: 0.5vh;
          height: 3vh;
          // background-color: #779DCE;
          display: flex;
          justify-content: space-between;
        }

        .screw-center-btn-2-1 {
          width: 42%;
          height: 2.5vh;
          background-color: #FFFF00;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          font-weight: 800;
          font-size: 1.2vh;
          color: #11151E;
          cursor: pointer;
        }

        .screw-center-btn-2-2 {
          width: 42%;
          height: 2.5vh;
          background-color: #FFFF00;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          font-weight: 800;
          font-size: 1.2vh;
          color: #11151E;
          cursor: pointer;
        }

        .screw-center-btn-3 {
          margin-top: 0.5vh;
          height: 2.5vh;
          background-color: #A21E1E;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          color: #11151E;
          font-weight: 800;
          font-size: 1.3vh;
          cursor: pointer;
        }

        .screw-center-btn-3:active {
          background-color: #e92525;
        }

        .screw-center-btn-4 {
          margin-top: 1vh;
          height: 2.5vh;
          background-color: #7B99D5;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          font-weight: 800;
          font-size: 1.3vh;
          color: #11151E;
        }

        .zhileng {
          color: #FFFF00;
          cursor: pointer;
        }

        .xiegang {
          color: #777D81;
        }

        .zhire {
          color: #FFFF00;
          cursor: pointer;
        }
      }

      .screw-center-btn {
        width: 100%;
        height: 16vh;
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
        // text-align: right;
        // position: relative;
        box-sizing: border-box;
        // padding: 0px 20px 0px 20px;

        .screw-center-btn-1 {
          height: 2.5vh;
          background-color: #265e20;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          color: #11151E;
          font-weight: 800;
          font-size: 1.3vh;
          cursor: pointer;
        }

        .screw-center-btn-1:active {
          background-color: #32b623;
        }

        .screw-center-btn-2 {
          margin-top: 0.5vh;
          height: 3vh;
          // background-color: #779DCE;
          display: flex;
          justify-content: space-between;
        }

        .screw-center-btn-2-1 {
          width: 42%;
          height: 2.5vh;
          background-color: #FFFF00;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          font-weight: 800;
          font-size: 1.2vh;
          color: #11151E;
          cursor: pointer;
        }

        .screw-center-btn-2-2 {
          width: 42%;
          height: 2.5vh;
          background-color: #FFFF00;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          font-weight: 800;
          font-size: 1.2vh;
          color: #11151E;
          cursor: pointer;
        }

        .screw-center-btn-3 {
          margin-top: 0.5vh;
          height: 2.5vh;
          background-color: #A21E1E;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          color: #11151E;
          font-weight: 800;
          font-size: 1.3vh;
          cursor: pointer;
        }

        .screw-center-btn-3:active {
          background-color: #D92323;
        }

        .screw-center-btn-4 {
          margin-top: 1vh;
          height: 2.5vh;
          background-color: #7B99D5;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          font-weight: 800;
          font-size: 1.3vh;
        }

        .zhileng {
          color: #FFFF00;
          cursor: pointer;
        }

        .xiegang {
          color: #777D81;
        }

        .zhire {
          color: #FFFF00;
          cursor: pointer;
        }

        .screw-btn-box {
          width: 27%;
          height: 90%;
          cursor: pointer;
          color: #FFFFFF;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 1.5vh;
          font-weight: 800
        }

        .screw-btn-cool {
          width: 15%;
          height: 1.8vh;
          background-image: url('../../../static/img/sicon/zhileng.png');
          background-size: 100% 100%;
          margin-left: 4%;
        }

        .screw-btn-hot {
          width: 15%;
          height: 1.8vh;
          background-image: url('../../../static/img/sicon/zhire.png');
          background-size: 100% 100%;
          margin-left: 4%;
        }
      }
    }

    .screw-body-inner-right {
      width: 43%;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      box-sizing: border-box;

      .screw-right-main11 {
        width: 92%;
        height: 16vh;
        background-image: url('../../../static/img/sicon/screw10.png');
        background-size: 100% 100%;

        .screw-left-main10-all {
          width: 100%;
          height: 3vh;
          display: flex;
          padding: 0 8vh 0 8vh;
          align-items: center;
          justify-content: space-between;
        }

        .screw-left-main10-left {
          font-size: 1.8vh;
          font-weight: 900;
          color: #8ABCF4;
        }

        .screw-left-main10-right {
          font-size: 2vh;
          font-weight: 800;
          color: #8ABCF4;
        }
      }

      .screw-right-main9 {
        width: 92%;
        height: 16vh;
        background-image: url('../../../static/img/sicon/screw10.png');
        background-size: 100% 100%;

        .screw-left-main10-all {
          width: 100%;
          height: 3vh;
          display: flex;
          padding: 0 8vh 0 8vh;
          align-items: center;
          justify-content: space-between;
        }

        .screw-left-main10-left {
          font-size: 1.8vh;
          font-weight: 900;
          color: #8ABCF4;
        }

        .screw-left-main10-right {
          font-size: 2vh;
          font-weight: 800;
          color: #8ABCF4;
        }
      }

      .screw-right-main7 {
        width: 92%;
        height: 16vh;
        background-image: url('../../../static/img/sicon/screw10.png');
        background-size: 100% 100%;

        .screw-left-main10-all {
          width: 100%;
          height: 3vh;
          display: flex;
          padding: 0 8vh 0 8vh;
          align-items: center;
          justify-content: space-between;
        }

        .screw-left-main10-left {
          font-size: 1.8vh;
          font-weight: 900;
          color: #8ABCF4;
        }

        .screw-left-main10-right {
          font-size: 2vh;
          font-weight: 800;
          color: #8ABCF4;
        }
      }

      .screw-right-main5 {
        width: 92%;
        height: 16vh;
        background-image: url('../../../static/img/sicon/screw10.png');
        background-size: 100% 100%;

        .screw-left-main10-all {
          width: 100%;
          height: 3vh;
          display: flex;
          padding: 0 8vh 0 8vh;
          align-items: center;
          justify-content: space-between;
        }

        .screw-left-main10-left {
          font-size: 1.8vh;
          font-weight: 900;
          color: #8ABCF4;
        }

        .screw-left-main10-right {
          font-size: 2vh;
          font-weight: 800;
          color: #8ABCF4;
        }
      }

      .screw-right-main3 {
        width: 92%;
        height: 16vh;
        background-image: url('../../../static/img/sicon/screw10.png');
        background-size: 100% 100%;

        .screw-left-main10-all {
          width: 100%;
          height: 3vh;
          display: flex;
          padding: 0 8vh 0 8vh;
          align-items: center;
          justify-content: space-between;
        }

        .screw-left-main10-left {
          font-size: 1.8vh;
          font-weight: 900;
          color: #8ABCF4;
        }

        .screw-left-main10-right {
          font-size: 2vh;
          font-weight: 800;
          color: #8ABCF4;
        }
      }

      .screw-right-main1 {
        width: 92%;
        height: 16vh;
        background-image: url('../../../static/img/sicon/screw10.png');
        background-size: 100% 100%;

        .screw-left-main10-all {
          width: 100%;
          height: 3vh;
          display: flex;
          padding: 0 8vh 0 8vh;
          align-items: center;
          justify-content: space-between;
        }

        .screw-left-main10-left {
          font-size: 1.8vh;
          font-weight: 900;
          color: #8ABCF4;
        }

        .screw-left-main10-right {
          font-size: 2vh;
          font-weight: 800;
          color: #8ABCF4;
        }
      }
    }
  }
}

.btn-on1 {
  background-image: url('../../../static/img/sicon/screwBtn01.png');
  background-size: 100% 100%;
}

.btn-on2 {
  background-image: url('../../../static/img/sicon/serwchBtn02.png');
  background-size: 100% 100%;
}

.btn-on3 {
  background-image: url('../../../static/img/sicon/screwBtn03.png');
  background-size: 100% 100%;
}

.btn-on4 {
  background-image: url('../../../static/img/sicon/screwBtn04.png');
  background-size: 100% 100%;
  color: #006effb1;
  // background-color: #2284ca;
}
</style>



// WEBPACK FOOTER //
// src/components/graphically/screwShowTwo.vue